import { TagInterface, TagMixin } from 'riot';
import { constants, coreStore } from '@ambita/ambita-components-core';

const { core: coreConstants } = constants;

export interface AuthMixin extends TagMixin {
  isValidTokenAvailable?: boolean;
  onTokenChange(this: TagInterface & AuthMixin): void;
}

export const authMixin: AuthMixin = {
  init(this: TagInterface & AuthMixin): void {
    this.isValidTokenAvailable = coreStore.isValidToken();

    this.on('mount', () => {
      coreStore.on(coreConstants.TOKEN_CHANGE_EVENT, this.onTokenChange);
    });

    this.on('unmount', () => {
      coreStore.off(coreConstants.TOKEN_CHANGE_EVENT, this.onTokenChange);
    });
  },

  onTokenChange(this: TagInterface & AuthMixin): void {
    this.isValidTokenAvailable = coreStore.isValidToken();
    this.update();
  }
};

export default authMixin;
